"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textField = exports.stepField = void 0;

var _util = require("../../../util");

const stepField = ({
  theme
}) => ({
  height: 48,
  backgroundColor: (0, _util.color)(theme, 'field.1'),
  borderRadius: (0, _util.spacing)(theme, 'xsmall'),
  '& > button:disabled, button:hover:disabled': {
    backgroundColor: "".concat((0, _util.color)(theme, 'disabled.2'), " !important")
  }
});

exports.stepField = stepField;

const textField = () => ({
  flex: 1,
  justifyContent: 'center'
});

exports.textField = textField;
//# sourceMappingURL=StepInputField.style.js.map